import { http_get, http_put, http_delete } from './helpers';
import { version } from './config';
import {
    ProductCard, FilterBrand, FilterCategory, FilterFileType, FilterAdvanced, CompareList,
} from './types';

/**
 * 获取产品列表
 */
export const getProductList = http_put<
    {
        keyword?: string;
        brandIds?: number[] | string[];
        fileTypeNames?: string[];
        categoryIds?: number[] | string[];
        sorting?: string;
        skipCount?: number;
        maxResultCount?: number;
        highFilterProperties?: {
            keyword: string;
            rangeInput?: {
                minValue: number;
                maxValue: number;
                isAsc: boolean;
            };
            listSelectValue?: string;
        }[];
        getCorrelationOfPVId?: string;
    },
    {
        totalCount: number;
        items: ProductCard[];
    }
>(`/api/v${version}/m/Product`);

/**
 * 获取产品列表的数量
 */
export const getProductListCount = http_put<
    {
        keyword?: string;
        brandIds?: number[];
        fileTypeNames?: string[];
        categoryIds?: number[];
        sorting?: string;
        skipCount?: number;
        maxResultCount?: number;
        getCorrelationOfPVId?: string;
        highFilterProperties?: any[];
    },
    {
        brandCount: number;
        productCount: number;
    }
>(`/api/v${version}/m/Product/SearchCount`);

/**
 * 获取品牌详情界面的产品列表筛选属性
 */
export const getBrandProductFilter = http_get<
    {
        brandId?: string;
    },

    {
        categories: FilterCategory[];
        fileTypes: FilterFileType[];
    }
>(`/api/v${version}/m/Product/FilterProperties`);

/**
 * 获取产品列表的筛选属性
 */
export const getProductFilter = http_get<
    {
        keyword: string;
        brandIds: string[] | number[];
        categoryIds: string[] | number[];
        fileTypeNames: string[] | number[];
        highFilterProperties: any[];
    },
    {
        brands: FilterBrand[];
        categories: FilterCategory[];
        fileTypes: FilterFileType[];
    }
>(`/api/v${version}/m/Product/FilterProperties`);

/**
 * 获取产品列表的高级筛选
 */
export const getProductFilterAdvanced = http_get<
    {
        productName: string | null;
        brandIds: number[];
        fileTypeNames: string[];
        categoryIds: number[];
    },
    FilterAdvanced[]
>(`/api/v${version}/m/Product/HighFilterProperties`);

/**
 * 获取用户产品对比列表
 */
export const getProductCompareList = http_get<
    void,
    CompareList[]
>(`/api/v${version}/m/ProductContrastSelection`);

/**
 * 选择用户对比的产品
 */
export const putProductCompare = http_put<
    {
        'productId': string;
        'pvId': string;
    },
    void
>(`/api/v${version}/m/ProductContrastSelection`);

/**
 * 清空用户对比的产品列表
 */
export const deleteAllProductCompare = http_delete<
    void,
    void
>(`/api/v${version}/m/ProductContrastSelection`);

/**
 * 通过Id删除用户对比的产品
 */
export const deleteProductCompareById = http_delete<
    {
        productId: string;
    },
    void
>(`/api/v${version}/m/ProductContrastSelection/{productId}`);
